import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtTextFieldPWD from "../Components/CustomTool/CtTxtPWD";
import CtCmb from "../Components/CustomTool/CtCmb";
import CtTxtNum from "../Components/CustomTool/CtTxtNum";
import MaterialTable from "../Components/CustomTool/MaterialTable";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import { Stack } from "@mui/material";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import { fetchcarinside, fetchUser } from "./API";
import MobileTable from "./CustomTool/MobileTable";
import CtART from "./CustomTool/ResponsiveTable";
import axios from "axios";
import CtTxtAmt from "../Components/CustomTool/CtTxtAmt";
import CtCmbEditable from "./CustomTool/CtCmbEditable";

class CarInsideDbgCwSelection extends Component {
  state = {
    Unit: [{ vac_type: "Type" }],
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "bint_srno",
      },
      {
        accessorKey: "vac_type",
        header: "Type",
      },
      {
        accessorKey: "dec_passenger",
        header: "Passenger / Load Capacity",
      },
      {
        accessorKey: "dec_carwidth",
        header: "Car Inside Widht",
        size: 220,
      },

      {
        accessorKey: "dec_cardepth",
        header: "Car Inside Depth",
        size: 225,
      },
      {
        accessorKey: "dec_dbg",
        header: "Car DGB",
      },
      {
        accessorKey: "dec_CWdgb",
        header: "C/W DGB",
      },
    ],

    rows: [],
    formData: {
      bint_srno: "",
      cmbType: "",
      txtPassenger: "",
      txtCarInsideWidht: "",
      txtCarInsideDepth: "",
      txtCarDGB: "",
      txtCWDGB: "",
    },
    Type: [{ vac_type: "Passenger" }, { vac_type: "Load Capacity" }],
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    // document.title = "User Management : Top India";
    localStorage.setItem(
      "Heading",
      "Master For Car Inside, Car DBG & C/W DBG Selection"
    );
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      this.props.modules.carinsidecardbgcwdbg
    );
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.SaveCarInside,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtPassenger
        );
      }
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_type",
      "dec_passenger",
      "dec_carwidth",
      "dec_cardepth",
      "dec_dbg",
      "dec_CWdgb",
    ]);
    let bint_srno = row.bint_srno,
      cmbType = row.vac_type,
      txtPassenger = row.dec_passenger,
      txtCarInsideWidht = row.dec_carwidth,
      txtCarInsideDepth = row.dec_cardepth,
      txtCarDGB = row.dec_dbg,
      txtCWDGB = row.dec_CWdgb;

    console.log("row", row);

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          cmbType,
          txtPassenger,
          txtCarInsideWidht,
          txtCarInsideDepth,
          txtCarDGB,
          txtCWDGB,
        },
      },
      () => {
        document.getElementById("cmbType").focus();
      }
    );
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "dec_passenger"]);
    // console.log("row", row.bint_srno, row.vac_userid);
    this.DeleteData(row.bint_srno, row.dec_passenger);
  };

  //#endregion Handle

  //#region function

  DeleteData = (bint_srno, dec_passenger) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Passenger : " + dec_passenger + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteCarInside(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteCarInside = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteCarInside_Selection",
      bint_srno: bint_srno,
    };
    fetchcarinside(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.ListCarInside_Selection &&
            res.data.ListCarInside_Selection.length > 0
          ) {
            rows = res.data.ListCarInside_Selection;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            }
          );
          document.getElementById("cmbType").focus();
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Rail Price Master. " + error
        );
      });
    return false;
  };

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListCarInside_Selection",
    };
    fetchcarinside(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.ListCarInside_Selection,
          rowsCount = rows.length;
        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("cmbType").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: "",
          cmbType: "",
          txtPassenger: "",
          txtCarInsideWidht: "",
          txtCarInsideDepth: "",
          txtCarDGB: "",
          txtCWDGB: "",
        },
      },
      () => {
        document.getElementById("cmbType").focus();
      }
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationRailPrice = () => {
    let result = false;
    if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (this.state.formData.txtPassenger.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Passenger / Load Capacity ",
        "txtPassenger"
      );
    } else if (
      this.state.formData.txtCarInsideWidht.length > 0 &&
      Number(this.state.formData.txtCarInsideWidht) == NaN
    ) {
      this.props.toastErrorMsg(
        "Select Or Enter valid Car Inside Widht",
        "txtCarInsideWidht"
      );
    } else if (
      this.state.formData.txtCarInsideDepth.length > 0 &&
      Number(this.state.formData.txtCarInsideDepth) == NaN
    ) {
      this.props.toastErrorMsg(
        "Select Or Enter valid Car Inside Depth",
        "txtCarInsideDepth"
      );
    } else if (
      this.state.formData.txtCarDGB.length > 0 &&
      Number(this.state.formData.txtCarDGB) == NaN
    ) {
      this.props.toastErrorMsg("Select Or Enter valid Car DGB", "txtCarDGB");
    } else if (
      this.state.formData.txtCWDGB.length > 0 &&
      Number(this.state.formData.txtCWDGB) == NaN
    ) {
      this.props.toastErrorMsg("Select Or Enter valid CW DGB", "txtCWDGB");
    } else {
      result = true;
    }
    return result;
  };

  SaveCarInside = () => {
    this.trimFormData(() => {
      if (this.validationRailPrice()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveCarInside_Selection",
          vac_type: this.state.formData.cmbType,
          bint_srno: this.state.formData.bint_srno,
          dec_passenger: this.state.formData.txtPassenger,
          dec_carwidth: this.state.formData.txtCarInsideWidht,
          dec_cardepth: this.state.formData.txtCarInsideDepth,
          dec_dbg: this.state.formData.txtCarDGB,
          dec_CWdgb: this.state.formData.txtCWDGB,
        };
        fetchcarinside(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.ListCarInside_Selection &&
                res.data.ListCarInside_Selection.length > 0
              ) {
                rows = res.data.ListCarInside_Selection;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in Save Rail Price Master .",
              error
            );
          });
      }
    });
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.SaveCarInside}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtPassenger
                    );
                  }}
                  disabled={
                    Number(this.state.formData.bint_srno) > 0 ? false : true
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbType"
              label="Type*"
              items={this.state.Type}
              value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              colID="vac_type"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtPassenger"
              label="Passenger / Load Capacity*"
              value={this.state.formData.txtPassenger}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={220}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtCarInsideWidht"
              label="Car Inside Widht"
              value={this.state.formData.txtCarInsideWidht}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={180}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtCarInsideDepth"
              label="Car Inside Depth"
              value={this.state.formData.txtCarInsideDepth}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={180}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtCarDGB"
              label="Car DGB"
              value={this.state.formData.txtCarDGB}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={180}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtCWDGB"
              label="C/W DGB"
              value={this.state.formData.txtCWDGB}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={180}
              maxLength={10}
              defaultAction={this.SaveCarInside}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          {/* responsive table */}
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Passenger Lift Cabin Price")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={90}
              density={"compact"}
              hideColIdList={["bint_srno"]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <CarInsideDbgCwSelection {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
